// Framework
import pop from './components';

// Components
import AiSearch from './components/ai-search';
import BackgroundImageSpotlight from './components/background-image-spotlight';
import CardDetailCarousel from './components/card-detail-carousel';
import EntryShareButton from './components/entry-share-button';
import EntryShareForm from './components/entry-share-form';
import FeaturedCategories from './components/featured-categories';
import FeaturedForm from './components/featured-form';
import FeaturedMarkets from './components/featured-markets';
import FeaturedPages from './components/featured-pages';
import FilterableListing from './components/filterable-listing';
import Footer from './components/footer';
import FormField from './components/form-field';
import Header from './components/header';
import InfrastructureCompareBar from './components/infrastructure-compare-bar';
import InfrastructureProductDialog from './components/infrastructure-product-dialog';
import JumpLinks from './components/jump-links';
import LocationsListing from './components/locations-listing';
import Main from './components/main';
import Modal from './components/modal';
import PriceLists from './components/price-lists';
import PrimaryHero from './components/primary-hero';
import QuotesCarousel from './components/quotes-carousel';
import SalesRepSearch from './components/sales-rep-search';
import SearchInput from './components/search-input';
import SearchResults from './components/search-results';
import SlidesCarousel from './components/slides-carousel';
import Timeline from './components/timeline';
import Tooltip from './components/tooltip';
import Video from './components/video';
import VideoCarousel from './components/video-carousel';
// import VideoCard from './components/video-card';
import WeirFlowChart from './components/weir-flow-chart';
import { initWeirPdfExport } from './components/weir-pdf-export';

// Define map of component handles to component classes
const classMap = {
    'ai-search': AiSearch,
    'background-image-spotlight': BackgroundImageSpotlight,
    'card-detail-carousel': CardDetailCarousel,
    'entry-share-button': EntryShareButton,
    'entry-share-form': EntryShareForm,
    'featured-categories': FeaturedCategories,
    'featured-form': FeaturedForm,
    'featured-markets': FeaturedMarkets,
    'featured-pages': FeaturedPages,
    'filterable-listing': FilterableListing,
    footer: Footer,
    'form-field': FormField,
    header: Header,
    'infrastructure-compare-bar': InfrastructureCompareBar,
    'jump-links': JumpLinks,
    'locations-listing': LocationsListing,
    main: Main,
    modal: Modal,
    'price-lists': PriceLists,
    'primary-hero': PrimaryHero,
    'quotes-carousel': QuotesCarousel,
    'sales-rep-search': SalesRepSearch,
    'search-input': SearchInput,
    'search-results': SearchResults,
    'slides-carousel': SlidesCarousel,
    timeline: Timeline,
    tooltip: Tooltip,
    video: Video,
    'video-carousel': VideoCarousel,
    // 'video-card': VideoCard,
    'weir-flow-chart': WeirFlowChart,
};

// Define all actions/commands that components pub/sub
const actions = {
    // Action events
    lockScroll: 'lock-scroll',
    unlockScroll: 'unlock-scroll',
    showOverlay: 'show-overlay',
    hideOverlay: 'hide-overlay',
    openModal: 'open-modal',
    closeModal: 'close-modal',
    loadModal: 'load-modal',
    openAiSearch: 'open-ai-search',
    closeAiSearch: 'close-ai-search',
    askAiSearch: 'ask-ai-search',
    resetPage: 'resetPage',
    showFieldError: 'show-field-error',
};

// Event handler functions
function handleDOMConentLoaded() {
    InfrastructureProductDialog();
    initWeirPdfExport();

    function cb() {
        // Do anything after components are created.
    }

    pop({ classMap, actions, cb });
}

// Add event listeners
document.addEventListener('DOMContentLoaded', handleDOMConentLoaded);
